import { defineNuxtPlugin } from '#app'
import posthog from 'posthog-js'

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()
  const posthogClient = posthog.init(runtimeConfig.public.posthogPublicKey, {
    api_host: runtimeConfig.public.posthogHost || 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: false, // we add manual pageview capturing below
    capture_pageleave: true,
    persistence: 'localStorage+cookie',
    session_recording: {
      // Mask all input/textarea values in replays: the contact form carries
      // name/email/message and must never leak into session recordings.
      maskAllInputs: true,
      maskInputOptions: {
        password: true
      }
    },
    // Enable exception autocapture
    autocapture: {
      capture_copied_text: false
    },
    loaded: (posthog) => {
      if (import.meta.env.MODE === 'development') posthog.debug()
    }
  })

  // Make sure that pageviews are captured with each route change
  const router = useRouter()
  router.afterEach((to) => {
    nextTick(() => {
      posthog.capture('$pageview', {
        current_url: to.fullPath
      })
    })
  })

  // Capture unhandled errors and exceptions
  if (import.meta.client) {
    globalThis.addEventListener('error', (event) => {
      posthog.capture('$exception', {
        $exception_type: event.error?.name || 'Error',
        $exception_message: event.message,
        $exception_stack_trace_raw: event.error?.stack || '',
        $exception_source: event.filename,
        $exception_lineno: event.lineno,
        $exception_colno: event.colno,
        $exception_handled: false,
        $exception_level: 'error'
      })
    })

    // Capture unhandled promise rejections
    globalThis.addEventListener('unhandledrejection', (event) => {
      posthog.capture('$exception', {
        $exception_type: event.reason?.name || 'UnhandledRejection',
        $exception_message: event.reason?.message || String(event.reason),
        $exception_stack_trace_raw: event.reason?.stack || '',
        $exception_handled: false,
        $exception_level: 'error'
      })
    })
  }

  return {
    provide: {
      posthog: () => posthogClient
    }
  }
})
